/**
 * Auth debug logging - enabled when REACT_APP_DEBUG_AUTH=true or 1.
 * Use for [Auth] and [PostLoginMFA] logs during development.
 */
export const DEBUG_AUTH =
  process.env.REACT_APP_DEBUG_AUTH === 'true' ||
  process.env.REACT_APP_DEBUG_AUTH === '1';

export function debugAuthLog(...args: unknown[]): void {
  if (DEBUG_AUTH) console.log(...args);
}

export function debugAuthError(...args: unknown[]): void {
  if (DEBUG_AUTH) console.error(...args);
}
